import { Env } from "../app/common/interfaces/global.interface";

export const ENV: Env = {
  production: false,

  //Testing environment
  frontendUrl: "https://demotaasisi.hakijinai.gov.go.tz",
  serverUrl: "https://demoutawala.hakijinai.gov.go.tz/api",
  hajisGraphqlUrl: "https://demoutawala.hakijinai.gov.go.tz/api/graphql",
  genericGraphqlUrl: "https://demotaasisi.hakijinai.gov.go.tz/api/graphql",
};
